// RT1/CS message shape: the server's refusal text. JsonApi.error sends {"error": "<message>"}; some callers
// were written for {"error": {"message": "<message>"}}. Reads both; '' when there is none.
export function serverMessage(err) {
  const data = err && err.response && err.response.data
  const error = data && data.error
  const text = typeof error === 'string' ? error : (error && typeof error.message === 'string' ? error.message : '')
  return text.trim()
}
